import { Mapper } from "planning-portal-library/src/lib/core/base";
import { LocationCountByLocationType } from "planning-portal-library/src/lib/core/domain/models/plan-container-location-count";
import { LocationCountByLocationTypeWebEntity } from "./location-count-web-entity";

export class LocationCountByLocationTypeWebRepositoryMapper extends Mapper<
  LocationCountByLocationTypeWebEntity,
  LocationCountByLocationType
> {
  constructor() {
    super();
  }

  mapFrom(param: LocationCountByLocationTypeWebEntity): LocationCountByLocationType {
    return {
      locationType: param.locationType,
      noOfLocations: param.noOfLocations
    };
  }

  mapTo(param: LocationCountByLocationType): LocationCountByLocationTypeWebEntity {
    return {
      locationType: param.locationType,
      noOfLocations: param.noOfLocations

    };
  }
}
